// Libraries
import React from 'react';
import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Text,
  Line,
  LineChart,
} from 'recharts';

// Enums
import { SingleSelectQuestionDataType } from 'engagementReport/enums/propTypes';

// Components
import CustomTooltip from 'admin/engagement/reporting/components/CustomTooltip';

const tooltipAttributes = [
  { tooltipLabel: 'Percentage', payloadKey: 'percentage', percentage: true },
  { tooltipLabel: 'Count', payloadKey: 'count' },
];

const SingleSelectLineChart = ({ data }) => {
  const padding = (1 / data.length) * 250;

  return (
    <ResponsiveContainer width="100%" aspect={16 / 9}>
      {/* eslint-disable react/prop-types */}
      <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
        <CartesianGrid vertical={false} stroke="#e8e8e8" strokeWidth={1} />
        <Tooltip
          content={<CustomTooltip attributes={tooltipAttributes} />}
          isAnimationActive={false}
        />
        <Line
          type="monotone"
          dataKey="percentage"
          stroke="#4a90e2"
          strokeWidth={2}
          animationDuration={800}
        />
        <XAxis
          type="category"
          dataKey="label"
          tickLine={false}
          tick={(props) => (
            <Text {...props} width={props.width / data.length - 10} fontSize={14}>
              {props.payload.value}
            </Text>
          )}
          stroke="#636363"
          strokeWidth={1}
          interval={0}
          padding={{ left: padding, right: padding }}
        />
        <YAxis
          type="number"
          domain={[0, 100]}
          ticks={[0, 25, 50, 75, 100]}
          tickLine={false}
          unit="%"
          interval={0}
          axisLine={false}
        />
      </LineChart>
      {/* eslint-enable react/prop-types */}
    </ResponsiveContainer>
  );
};

SingleSelectLineChart.propTypes = {
  data: SingleSelectQuestionDataType.isRequired,
};

export default SingleSelectLineChart;
